module.exports = __webpack_public_path__ + "img/hz5.a5fab53b.png";